export function generateRandomString(length: number = 10): string {
	const len = 10;
	if (length / len > 1) {
		return generateRandomString(len) + generateRandomString(length - len);
	}

	return Math.random().toString(36).substr(2, len).substr(0, length);
}
